// test346
(346 && 0);
